import React, { useContext, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import styled from 'styled-components';
import InputCustom from '../elements/InputCustom';
import { dataObjectOpenAnswer, } from '../../helpers/functions';
import { ConfigurationContext } from '../../context';
import { useTranslation } from 'react-i18next';
import ButtonCustom from '../elements/ButtonCustom';
import { GrPowerReset } from "react-icons/gr";


const WrapperStyled = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .form_complete_blanks{
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        margin-top: 10px;
        .bt_add_word{
            cursor: pointer;
            margin-left: 10px;
        }
        .bt_reset{
            font-size: 25px;
            
            margin-left: 10px;
            padding: 10px!important;
            background-color: ${props => `rgb(${props.pancolors.red})`}!important;
            border-color: ${props => `rgb(${props.pancolors.red})`}!important;
            &:hover{
                >.icon{
                    svg{
                        color: ${props => `rgb(${props.pancolors.red})`}!important;
                    }
                }
                background-color: transparent!important;
            }
            >.icon{
                color: #FFFFFF;
                margin-right: 0!important;
            }
            &.disabled{
                background-color: rgb(186, 186, 194)!important;
                border: 1px solid rgb(186, 186, 194)!important;
                &:hover{
                    >.icon{
                        svg{
                            color: #FFFFFF!important;
                        }
                    }
                }
            }
        }
    }
    .phrase_validation_title{
        margin-top: 10px;
        font-weight: 600;
        font-size: 14px;
    }
    .phrase_validation{
        margin-top: 5px;
        color: ${props => `rgb(${props.pancolors.dots})`};
        border: 1px dashed ${props => `rgb(${props.pancolors.dots})`};
        padding: 10px;
    }
    .phrase_validation_complete_title{
        margin-top: 20px;
        font-weight: 600;
        font-size: 14px;
    }
    .phrase_validation_complete{
        font-weight: 600;
        margin-top: 5px;
        color: ${props => `rgb(${props.pancolors.green})`};
        border: 1px dashed ${props => `rgb(${props.pancolors.green})`};
        padding: 10px;
    }
    .field_answer_text{
        width: 550px;
        margin-top: 20px;
    }
    .field_answer_help{
        width: 550px;
        margin-top: 5px;
        font-size: 13px;
        line-height: 16px;
    }
    .title{
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        color: ${props => `rgb(${props.pancolors.black_overwhite})`};
        margin-top: 35px;
        margin-bottom: 20px;
    }
    .field_title{
        margin-top: 25px;
    }
    .field_question_text{
        margin-top: 25px;
    }
    .box_options{
        display: flex;
        flex-direction: row;
        margin-top: 20px;
        .option{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 20px;
            border: 2px solid ${props => `rgb(${props.pancolors.dark_gray})`};
            border-radius: 8px;
            box-sizing: border-box;
            padding: 10px 15px;
            margin-left: 10px;
            color: ${props => `rgb(${props.pancolors.dark_gray})`};
            font-weight: 600;
            &.exist{
                border-color: ${props => `rgb(${props.pancolors.dots})`};
                background-color: ${props => `rgb(${props.pancolors.dots})`};
                color: #FFFFFF;
            }
            .close{
                cursor: pointer;
                :hover{
                    color: ${props => `rgb(${props.pancolors.red})`};
                }
            }
            :first-child {
                margin-left: 0;
            }
            p{
                margin: 0 0 0 5px;
            }
        }
    }
`

const CompleteBlanks = (props) => {

    const { t } = useTranslation();

    const { panColors } = useContext(ConfigurationContext);

    const { contentByLang, 
            setContentByLang,
            questions,
            questionSelected,
            setQuestionSelected,
            lang = null,
            questionSelectedOrder} = props;
    
    const [ questionsList, setQuestionsList ] = useState([]);
    const [ errorWords, setErrorWords ] = useState([]);
    const [ errorTimeOut, setErrorTimeOut ] = useState(null);
    const [ phrase, setPhrase ] = useState(""); 
    const [ phraseUnknow, setPhraseUnknow ] = useState(""); 

    const [ answerText, setAnswerText ] = useState({ 
        value: "", 
        required: true, 
        disabled: false, 
        ref: "answer_text", 
        label: "Ingrese la oración separando las palabras y las incognitas", 
        placeholder: "Ingresar palabra",
        help: "Si la frase o palabra es visible presioná Agregar palabra, en caso contrario Agregar incógnita",
        error: false 
    });

    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};
            
    const handleFormElementChange = (name, value) => {

        if(name === "answer_text"){
            let update = {...answerText};
                update.value = value;
                setAnswerText(update);
        }

    }

    const handleKeyDown = (key, name, value) => {
        if(errorTimeOut){
            clearTimeout(errorTimeOut);
        }
        setErrorWords([]);

        if (key === 'Enter') {

            const exist = handleWordExist(value);

            if(!exist){

                let update = {...answerText};
                update.value = "";
                setAnswerText(update);
                
                let contentByLangUpdate = {...contentByLang};
                contentByLangUpdate.translations[lang].questions[questionSelectedOrder].secondary_actions.push(JSON.parse(JSON.stringify(dataObjectOpenAnswer({id: uuid(), correct: true, label: value}))));
                setContentByLang(contentByLangUpdate);

            }else{

                setErrorWords(words => [...words, value]);
                const timeout = setTimeout(() => {
                    setErrorWords([]);
                }, 2000);
                setErrorTimeOut(timeout);

            }
        }
    }

    const handleWordExist = (word) => {

        let exist = false;
        contentByLang?.translations[lang]?.questions[questionSelectedOrder].secondary_actions.map((w, i) => {
            if(w.label.value === word){
                exist = true;
            }
        })
        return exist;

    }
    
    const handleRemoveWord = (_word) => {
        let remove_word = {...questionSelected};
        const filtered = contentByLang?.translations[lang]?.questions[questionSelectedOrder].secondary_actions.filter(word => word.id.value !== _word.id.value);
        //remove_word.translations[lang].secondary_actions = filtered;
        //setQuestionSelected(remove_word);

        let contentByLangUpdate = {...contentByLang};
        contentByLangUpdate.translations[lang].questions[questionSelectedOrder].secondary_actions = filtered;
        setContentByLang(contentByLangUpdate);

    }

    const handleResetPhrase = () => {
        setPhrase("");
        setPhraseUnknow("");
        let contentByLangUpdate = {...contentByLang};
            contentByLangUpdate.translations[lang].questions[questionSelectedOrder].secondary_actions = [];
            contentByLangUpdate.translations[lang].questions[questionSelectedOrder].title.value = "";
            contentByLangUpdate.translations[lang].questions[questionSelectedOrder].text_correct.value = "";
            setContentByLang(contentByLangUpdate);
    }

    const handleAddWord = (type, text) => {
        let phrase_update = phrase + " " + answerText.value;
        setPhrase(phrase_update/*prev => prev + " " + answerText.value*/);
        
        let phraseUnknow_update = phraseUnknow + (type === 'unknown' ? " ____" : " " + answerText.value);
        setPhraseUnknow(phraseUnknow_update/*prev => prev + (type === 'unknown' ? " ____" : " " + answerText.value)*/);
        
        let contentByLangUpdate = {...contentByLang};
        if(type === 'unknown'){

            
                contentByLangUpdate.translations[lang].questions[questionSelectedOrder].secondary_actions.push(JSON.parse(JSON.stringify(dataObjectOpenAnswer({id: uuid(), correct: true, label: answerText.value}))));
                
        }

        contentByLangUpdate.translations[lang].questions[questionSelectedOrder].title.value = phraseUnknow_update.trim();
        contentByLangUpdate.translations[lang].questions[questionSelectedOrder].text_correct.value = phrase_update.trim();
        setContentByLang(contentByLangUpdate);

        let update = {...answerText};
        update.value = "";
        setAnswerText(update);

    }

    useEffect(() => {

        if(Object.keys(contentByLang).length){
            setPhrase(contentByLang.translations[lang].questions[questionSelectedOrder].text_correct.value.trim());
            setPhraseUnknow(contentByLang.translations[lang].questions[questionSelectedOrder].title.value.trim());
        }
        
    
      return () => {}
    }, [contentByLang])
    

    useEffect(() => {
      
        if(questions){
            const questions_updates = questions.map((question, index) => {
                return {_id: question._id, name: (index + 1)}
            })
            setQuestionsList(questions_updates);
        }
    
      return () => {}
    }, [questions])
    
    
    return (
        <WrapperStyled pancolors={panColors}>
            
            {/* <InputCustom 
                name={contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.ref}
                label={t("texts."+contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.label)}
                placeholder={t("texts."+contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.placeholder)}
                onChange={handleFormElementChange}
                onKeyDown={null}
                className={`field field_${contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.ref}${contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.error ? " error" : ""}`}
                type="text"
                value={contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.value}
                help={contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.help}
                isRequired={contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.required}
                styles={ formStyle }
                label_icon={null}
                tooltip_content={null}
                haveError={contentByLang?.translations[lang]?.questions[questionSelectedOrder].title.error}
            /> */}

            {phrase.length ?
            <>
            <div className='phrase_validation_complete_title'>
                { t("texts.Frase completa") }
            </div>
            <div className='phrase_validation_complete'>
                { phrase }
            </div>
            </> : ""}

            {phraseUnknow.length ?
            <>
            <div className='phrase_validation_title'>
                { t("texts.Frase con icognitas") }
            </div>
            <div className='phrase_validation'>
                { phraseUnknow }
            </div>
            </> : ""}

            <div className='form_complete_blanks'>
                <InputCustom 
                    name={answerText.ref}
                    label={t("texts."+answerText.label)}
                    placeholder={t("texts."+answerText.placeholder)}
                    onChange={handleFormElementChange}
                    onKeyDown={null/*handleKeyDown*/}
                    className={`field field_${answerText.ref}${contentByLang?.translations[lang]?.questions[questionSelectedOrder].secondary_actions_error ? " error" : ""}`}
                    type="text"
                    value={answerText.value}
                    help={""/*answerText.help*/}
                    isRequired={answerText.required}
                    styles={ formStyle }
                    label_icon={null}
                    tooltip_content={null}
                    haveError={contentByLang?.translations[lang]?.questions[questionSelectedOrder].secondary_actions_error}
                />
                <div className='actions'>
                    <ButtonCustom 
                        className="bt_add_word"
                        text={t("texts.Agregar Palabra")}
                        onClick={(e) => answerText?.value?.length ? handleAddWord("word", e) : null}
                        style_type="normal"
                        disabled={answerText?.value?.length ? false : true}
                        icon={null}
                        background={{ normal: panColors.primary, hover: panColors.white }}
                        border={{ normal: panColors.primary, hover: panColors.primary }}
                        textcolor={{ normal: panColors.white, hover: panColors.primary }}
                    />
                    <ButtonCustom 
                        className="bt_add_word"
                        text={t("texts.Agregar Incognita")}
                        onClick={(e) => answerText?.value?.length ? handleAddWord("unknown", e) : null}
                        style_type="normal"
                        disabled={answerText?.value?.length ? false : true}
                        icon={null}
                        background={{ normal: panColors.primary, hover: panColors.white }}
                        border={{ normal: panColors.primary, hover: panColors.primary }}
                        textcolor={{ normal: panColors.white, hover: panColors.primary }}
                    />
                    <ButtonCustom 
                        className={`bt_reset${phraseUnknow?.length ? "" : " disabled"}`}
                        text={null}
                        onClick={(e) => handleResetPhrase()}
                        style_type="normal"
                        icon={<GrPowerReset />}
                        background={{ normal: panColors.primary, hover: panColors.white }}
                        border={{ normal: panColors.primary, hover: panColors.primary }}
                        textcolor={{ normal: panColors.white, hover: panColors.primary }}
                    />
                </div>
                
            </div>
            <div className='field_answer_help'>
                {t("texts.Si la frase o palabra va a ser visible presiona Agregar palabra, en caso contrario Agregar incognita")}
            </div>
            {Object.keys(contentByLang).length ?
            <div className="box_options">
                
                {contentByLang.translations[lang].questions[questionSelectedOrder].secondary_actions.map((word, index) => {
                    return(
                        <div key={`w-id-${index}`} className={`option${errorWords.includes(word.label.value) ? " exist" : ""}`}>
                            {/* <div className="close" onClick={() => handleRemoveWord(word)}>x</div> */}
                            <p>{ word.label.value }</p>
                        </div>
                    )
                })}
                
            </div>
            : ""}
        </WrapperStyled>
    );
}

export default React.memo(CompleteBlanks);